/* Generated from catalogue/aurora-import-review.csv. Do not edit by hand. */
export interface ImportedProductRecord {
  auroraId: string;
  slug: string;
  name: string;
  brand: string;
  category: string;
  packSize: string | null;
  observedAuroraGbpPence: number;
  retailPricePence: number;
  dateChecked: string;
  sourceUrl: string;
  likelyBundle: boolean;
  needsElectricalReview: boolean;
}

export const importedProductRecords: ImportedProductRecord[] = [
  {
    "auroraId": "324",
    "slug": "anua-3-ceramide-panthenol-moisture-barrier-cream-100ml",
    "name": "Anua 3 Ceramide Panthenol Moisture Barrier Cream 100ml",
    "brand": "Anua",
    "category": "moisturisers",
    "packSize": "100ml",
    "observedAuroraGbpPence": 2300,
    "retailPricePence": 2300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-3-ceramide-panthenol-moisture-barrier-cream-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "327",
    "slug": "anua-7-rice-ceramide-hydrating-barrier-serum-50ml",
    "name": "Anua 7 Rice Ceramide Hydrating Barrier Serum 50ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "50ml",
    "observedAuroraGbpPence": 2400,
    "retailPricePence": 2400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-7-rice-ceramide-hydrating-barrier-serum-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "330",
    "slug": "anua-8-hyaluronic-acid-hydrating-gentle-foaming-cleanser-150ml",
    "name": "Anua 8 Hyaluronic Acid Hydrating Gentle Foaming Cleanser 150ml",
    "brand": "Anua",
    "category": "cleansers",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1400,
    "retailPricePence": 1400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-8-hyaluronic-acid-hydrating-gentle-foaming-cleanser-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "333",
    "slug": "anua-8-hyaluronic-acid-moisturising-gentle-gel-cleanser-150ml",
    "name": "Anua 8 Hyaluronic Acid Moisturising Gentle Gel Cleanser 150ml",
    "brand": "Anua",
    "category": "cleansers",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1500,
    "retailPricePence": 1500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-8-hyaluronic-acid-moisturising-gentle-gel-cleanser-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "336",
    "slug": "anua-azelaic-10-hyaluron-redness-soothing-pad-230ml",
    "name": "Anua Azelaic 10 Hyaluron Redness Soothing Pad 230ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "230ml",
    "observedAuroraGbpPence": 2200,
    "retailPricePence": 2200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-azelaic-10-hyaluron-redness-soothing-pad-230ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "816",
    "slug": "anua-azelaic-acid-10-hyaluron-redness-soothing-serum-30ml-2",
    "name": "Anua Azelaic Acid 10 Hyaluron Redness Soothing Serum 30ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 2200,
    "retailPricePence": 2200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-azelaic-acid-10-hyaluron-redness-soothing-serum-30ml-2/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "342",
    "slug": "anua-azelaic-acid-3-cica-skin-clarifying-toner-250ml",
    "name": "Anua Azelaic Acid 3 Cica Skin Clarifying Toner 250ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "250ml",
    "observedAuroraGbpPence": 2000,
    "retailPricePence": 2000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-azelaic-acid-3-cica-skin-clarifying-toner-250ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "345",
    "slug": "anua-daily-radiance-routine-bundle",
    "name": "Anua Daily Radiance Routine Bundle",
    "brand": "Anua",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 7000,
    "retailPricePence": 7000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-daily-radiance-routine-bundle/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "620",
    "slug": "anua-double-cleansing-duo-bundle-2",
    "name": "Anua Double Cleansing Duo Bundle",
    "brand": "Anua",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 2900,
    "retailPricePence": 2900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-double-cleansing-duo-bundle-2/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "351",
    "slug": "anua-glass-skin-essential-bundle",
    "name": "Anua Glass Skin Essential Bundle",
    "brand": "Anua",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 7000,
    "retailPricePence": 7000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-glass-skin-essential-bundle/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "354",
    "slug": "anua-heartleaf-70-soothing-collagen-mask-4-sheets-38g",
    "name": "Anua Heartleaf 70 Soothing Collagen Mask (4 Sheets) 38g",
    "brand": "Anua",
    "category": "masks",
    "packSize": "4 Sheets",
    "observedAuroraGbpPence": 1600,
    "retailPricePence": 1600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-heartleaf-70-soothing-collagen-mask-4-sheets-38g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "357",
    "slug": "anua-heartleaf-77-clearpad-160ml",
    "name": "Anua Heartleaf 77 Clearpad 160ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "160ml",
    "observedAuroraGbpPence": 2200,
    "retailPricePence": 2200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-heartleaf-77-clearpad-160ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "360",
    "slug": "anua-heartleaf-77-soothing-toner-250ml",
    "name": "Anua Heartleaf 77% Soothing Toner 250ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "250ml",
    "observedAuroraGbpPence": 1900,
    "retailPricePence": 1900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-heartleaf-77-soothing-toner-250ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "363",
    "slug": "anua-heartleaf-pore-control-cleansing-oil-200ml",
    "name": "Anua Heartleaf Pore Control Cleansing Oil 200ml",
    "brand": "Anua",
    "category": "cleansers",
    "packSize": "200ml",
    "observedAuroraGbpPence": 1600,
    "retailPricePence": 1600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-heartleaf-pore-control-cleansing-oil-200ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "369",
    "slug": "anua-heartleaf-quercetinol-pore-deep-cleansing-foam-150ml",
    "name": "Anua Heartleaf Quercetinol Pore Deep Cleansing Foam 150ml",
    "brand": "Anua",
    "category": "cleansers",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1300,
    "retailPricePence": 1300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-heartleaf-quercetinol-pore-deep-cleansing-foam-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "375",
    "slug": "anua-niacinamide-10-txa-4-serum-30ml",
    "name": "Anua Niacinamide 10% + TXA 4% Serum 30ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 2200,
    "retailPricePence": 2200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-niacinamide-10-txa-4-serum-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "385",
    "slug": "anua-niacinamide-5-txa-brightening-pad-210ml",
    "name": "Anua Niacinamide 5 TXA Brightening Pad 210ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "210ml",
    "observedAuroraGbpPence": 2200,
    "retailPricePence": 2200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-niacinamide-5-txa-brightening-pad-210ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "388",
    "slug": "anua-nourishing-rice-set",
    "name": "Anua Nourishing Rice Set",
    "brand": "Anua",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 7000,
    "retailPricePence": 7000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-nourishing-rice-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "392",
    "slug": "anua-pdrn-100-hyaluronic-acid-booster-toner-250ml",
    "name": "Anua PDRN 100 Hyaluronic Acid Booster Toner 250ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "250ml",
    "observedAuroraGbpPence": 2000,
    "retailPricePence": 2000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-pdrn-100-hyaluronic-acid-booster-toner-250ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "395",
    "slug": "anua-pdrn-100-hyaluronic-acid-glow-pad-180ml",
    "name": "Anua PDRN 100 Hyaluronic Acid Glow Pad 180ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "180ml",
    "observedAuroraGbpPence": 2200,
    "retailPricePence": 2200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-pdrn-100-hyaluronic-acid-glow-pad-180ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "398",
    "slug": "anua-pdrn-hyaluronic-acid-100-moisturising-cream-60ml",
    "name": "Anua PDRN Hyaluronic Acid 100 Moisturising Cream 60ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "60ml",
    "observedAuroraGbpPence": 2400,
    "retailPricePence": 2400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-pdrn-hyaluronic-acid-100-moisturising-cream-60ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "733",
    "slug": "anua-pdrn-hyaluronic-acid-capsule-100-serum-30ml-2",
    "name": "Anua PDRN Hyaluronic Acid Capsule 100 Serum 30ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 2000,
    "retailPricePence": 2000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-pdrn-hyaluronic-acid-capsule-100-serum-30ml-2/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "404",
    "slug": "anua-pdrn-hyaluronic-acid-capsule-100-serum-mask-23ml",
    "name": "Anua PDRN Hyaluronic Acid Capsule 100 Serum Mask 23ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "23ml",
    "observedAuroraGbpPence": 2400,
    "retailPricePence": 2400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-pdrn-hyaluronic-acid-capsule-100-serum-mask-23ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "418",
    "slug": "anua-peach-70-niacin-brightening-collagen-mask-4-sheets-38g",
    "name": "Anua Peach 70 Niacin Brightening Collagen Mask (4 Sheets) 38g",
    "brand": "Anua",
    "category": "masks",
    "packSize": "4 Sheets",
    "observedAuroraGbpPence": 1900,
    "retailPricePence": 1900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-peach-70-niacin-brightening-collagen-mask-4-sheets-38g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "421",
    "slug": "anua-plumping-trio",
    "name": "Anua Plumping Trio",
    "brand": "Anua",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 6500,
    "retailPricePence": 6500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-plumping-trio/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "427",
    "slug": "anua-radiance-trio",
    "name": "Anua Radiance Trio",
    "brand": "Anua",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 6700,
    "retailPricePence": 6700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-radiance-trio/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "430",
    "slug": "anua-rice-70-glow-collagen-mask-4-sheets-38g",
    "name": "Anua Rice 70 Glow Collagen Mask (4 Sheets) 38g",
    "brand": "Anua",
    "category": "masks",
    "packSize": "70 G",
    "observedAuroraGbpPence": 1600,
    "retailPricePence": 1600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-rice-70-glow-collagen-mask-4-sheets-38g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "589",
    "slug": "anua-rice-70-glow-milky-toner-250ml-2",
    "name": "Anua Rice 70 Glow Milky Toner 250ml",
    "brand": "Anua",
    "category": "treatments",
    "packSize": "70 G",
    "observedAuroraGbpPence": 2200,
    "retailPricePence": 2200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-rice-70-glow-milky-toner-250ml-2/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "439",
    "slug": "anua-rice-70-intensive-moisturising-milk-150ml",
    "name": "Anua Rice 70 Intensive Moisturising Milk 150ml",
    "brand": "Anua",
    "category": "moisturisers",
    "packSize": "150ml",
    "observedAuroraGbpPence": 2400,
    "retailPricePence": 2400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-rice-70-intensive-moisturising-milk-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "442",
    "slug": "anua-rice-enzyme-brightening-cleansing-powder-40g",
    "name": "Anua Rice Enzyme Brightening Cleansing Powder 40g",
    "brand": "Anua",
    "category": "cleansers",
    "packSize": "40g",
    "observedAuroraGbpPence": 2200,
    "retailPricePence": 2200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-rice-enzyme-brightening-cleansing-powder-40g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "445",
    "slug": "anua-rice-glow-set",
    "name": "Anua Rice Glow Set",
    "brand": "Anua",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 6800,
    "retailPricePence": 6800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-rice-glow-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "457",
    "slug": "anua-serum-discovery-trio",
    "name": "Anua Serum Discovery Trio",
    "brand": "Anua",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 2400,
    "retailPricePence": 2400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-serum-discovery-trio/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "463",
    "slug": "anua-soothing-routine",
    "name": "Anua Soothing Routine",
    "brand": "Anua",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 9500,
    "retailPricePence": 9500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-soothing-routine/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "475",
    "slug": "anua-soothing-trio",
    "name": "Anua Soothing Trio",
    "brand": "Anua",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 5700,
    "retailPricePence": 5700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-soothing-trio/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "451",
    "slug": "anua-spf-50-silky-moisture-sun-cream-50ml",
    "name": "Anua SPF 50 Silky Moisture Sun Cream 50ml",
    "brand": "Anua",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 1500,
    "retailPricePence": 1500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-spf-50-silky-moisture-sun-cream-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "592",
    "slug": "armani-luminous-silk-foundation-30ml-various-shades",
    "name": "Armani Luminous Silk Foundation 30ml (Various Shades)",
    "brand": "Armani",
    "category": "makeup",
    "packSize": "30ml",
    "observedAuroraGbpPence": 3920,
    "retailPricePence": 3920,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/armani-luminous-silk-foundation-30ml-various-shades/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "595",
    "slug": "aveda-miraculous-oil-high-shine-hair-concentrate-50ml",
    "name": "Aveda Miraculous Oil High Shine Hair Concentrate 50ml",
    "brand": "Aveda",
    "category": "hair",
    "packSize": "50ml",
    "observedAuroraGbpPence": 3400,
    "retailPricePence": 3400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/aveda-miraculous-oil-high-shine-hair-concentrate-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "599",
    "slug": "aveeno-face-calm-restore-foaming-cleanser-200ml",
    "name": "Aveeno Face Calm & Restore Foaming Cleanser 200ml",
    "brand": "Aveeno",
    "category": "cleansers",
    "packSize": "200ml",
    "observedAuroraGbpPence": 1300,
    "retailPricePence": 1300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/aveeno-face-calm-restore-foaming-cleanser-200ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "602",
    "slug": "aveeno-face-calm-and-restore-oat-gel-moisturiser-50ml",
    "name": "Aveeno Face Calm and Restore Oat Gel Moisturiser 50ml",
    "brand": "Aveeno",
    "category": "moisturisers",
    "packSize": "50ml",
    "observedAuroraGbpPence": 1499,
    "retailPricePence": 1499,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/aveeno-face-calm-and-restore-oat-gel-moisturiser-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "887",
    "slug": "aveeno-face-calm-and-restore-oat-gel-moisturiser-50ml-2",
    "name": "Aveeno Face Calm and Restore Oat Gel Moisturiser 50ml",
    "brand": "Aveeno",
    "category": "moisturisers",
    "packSize": "50ml",
    "observedAuroraGbpPence": 1499,
    "retailPricePence": 1499,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/aveeno-face-calm-and-restore-oat-gel-moisturiser-50ml-2/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "983",
    "slug": "aveeno-skin-relief-body-oil-spray-200ml-2",
    "name": "Aveeno Skin Relief Body Oil Spray 200ml",
    "brand": "Aveeno",
    "category": "body-care",
    "packSize": "200ml",
    "observedAuroraGbpPence": 1049,
    "retailPricePence": 1049,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/aveeno-skin-relief-body-oil-spray-200ml-2/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1214",
    "slug": "beauty-of-joseon-apricot-blossom-peeling-gel-100ml",
    "name": "Beauty of Joseon Apricot Blossom Peeling Gel 100ml",
    "brand": "Beauty of Joseon",
    "category": "cleansers",
    "packSize": "100ml",
    "observedAuroraGbpPence": 1100,
    "retailPricePence": 1100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-apricot-blossom-peeling-gel-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1223",
    "slug": "beauty-of-joseon-best-selling-trio",
    "name": "Beauty of Joseon Best Selling Trio",
    "brand": "Beauty of Joseon",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 5100,
    "retailPricePence": 5100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-best-selling-trio/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1272",
    "slug": "beauty-of-joseon-calming-serum-green-tea-panthenol-30ml",
    "name": "Beauty of Joseon Calming Serum Green Tea + Panthenol 30ml",
    "brand": "Beauty of Joseon",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 1500,
    "retailPricePence": 1500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-calming-serum-green-tea-panthenol-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "748",
    "slug": "beauty-of-joseon-centella-asiatica-calming-mask-trio",
    "name": "Beauty of Joseon Centella Asiatica Calming Mask Trio",
    "brand": "Beauty of Joseon",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 600,
    "retailPricePence": 600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-centella-asiatica-calming-mask-trio/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1193",
    "slug": "beauty-of-joseon-complete-glass-skin-routine",
    "name": "Beauty Of Joseon Complete Glass Skin Routine",
    "brand": "Beauty of Joseon",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 8200,
    "retailPricePence": 8200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-complete-glass-skin-routine/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "778",
    "slug": "beauty-of-joseon-dynasty-cream-100ml",
    "name": "Beauty of Joseon Dynasty Cream 100ml",
    "brand": "Beauty of Joseon",
    "category": "moisturisers",
    "packSize": "100ml",
    "observedAuroraGbpPence": 2950,
    "retailPricePence": 2950,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-dynasty-cream-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "787",
    "slug": "beauty-of-joseon-dynasty-cream-50ml",
    "name": "Beauty of Joseon Dynasty Cream 50ml",
    "brand": "Beauty of Joseon",
    "category": "moisturisers",
    "packSize": "50ml",
    "observedAuroraGbpPence": 2100,
    "retailPricePence": 2100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-dynasty-cream-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1232",
    "slug": "beauty-of-joseon-dynasty-glow-duo",
    "name": "Beauty of Joseon Dynasty Glow Duo",
    "brand": "Beauty of Joseon",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 3600,
    "retailPricePence": 3600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-dynasty-glow-duo/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "863",
    "slug": "beauty-of-joseon-ginseng-cleansing-oil-210ml",
    "name": "Beauty of Joseon Ginseng Cleansing Oil 210ml",
    "brand": "Beauty of Joseon",
    "category": "cleansers",
    "packSize": "210ml",
    "observedAuroraGbpPence": 1700,
    "retailPricePence": 1700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-ginseng-cleansing-oil-210ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1138",
    "slug": "beauty-of-joseon-ginseng-essence-water-toner-150ml",
    "name": "Beauty of Joseon Ginseng Essence Water Toner 150ml",
    "brand": "Beauty of Joseon",
    "category": "treatments",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1550,
    "retailPricePence": 1550,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-ginseng-essence-water-toner-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "721",
    "slug": "beauty-of-joseon-glow-replenishing-rice-milk-toner-150ml",
    "name": "Beauty of Joseon Glow Replenishing Rice Milk Toner 150ml",
    "brand": "Beauty of Joseon",
    "category": "treatments",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1550,
    "retailPricePence": 1550,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-glow-replenishing-rice-milk-toner-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "858",
    "slug": "beauty-of-joseon-glow-serum-propolis-niacinamide-30ml",
    "name": "Beauty of Joseon Glow Serum Propolis + Niacinamide 30ml",
    "brand": "Beauty of Joseon",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 1500,
    "retailPricePence": 1500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-glow-serum-propolis-niacinamide-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "769",
    "slug": "beauty-of-joseon-green-plum-refreshing-cleanser-100ml",
    "name": "Beauty of Joseon Green Plum Refreshing Cleanser 100ml",
    "brand": "Beauty of Joseon",
    "category": "cleansers",
    "packSize": "100ml",
    "observedAuroraGbpPence": 1100,
    "retailPricePence": 1100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-green-plum-refreshing-cleanser-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1169",
    "slug": "beauty-of-joseon-ground-rice-and-honey-glow-mask-150ml",
    "name": "Beauty of Joseon Ground Rice and Honey Glow Mask 150ml",
    "brand": "Beauty of Joseon",
    "category": "masks",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1550,
    "retailPricePence": 1550,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-ground-rice-and-honey-glow-mask-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "630",
    "slug": "beauty-of-joseon-morning-essentials-duo-for-combo-oily-skin",
    "name": "Beauty of Joseon Morning Essentials Duo for Combo/ Oily Skin",
    "brand": "Beauty of Joseon",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 3650,
    "retailPricePence": 3650,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-morning-essentials-duo-for-combo-oily-skin/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "841",
    "slug": "beauty-of-joseon-radiance-cleansing-balm-100ml",
    "name": "Beauty of Joseon Radiance Cleansing Balm 100ml",
    "brand": "Beauty of Joseon",
    "category": "cleansers",
    "packSize": "100ml",
    "observedAuroraGbpPence": 1650,
    "retailPricePence": 1650,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-radiance-cleansing-balm-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1196",
    "slug": "beauty-of-joseon-red-bean-refreshing-pore-mask-140ml",
    "name": "Beauty of Joseon Red Bean Refreshing Pore Mask 140ml",
    "brand": "Beauty of Joseon",
    "category": "masks",
    "packSize": "140ml",
    "observedAuroraGbpPence": 1700,
    "retailPricePence": 1700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-red-bean-refreshing-pore-mask-140ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1226",
    "slug": "beauty-of-joseon-red-bean-water-gel-100ml",
    "name": "Beauty of Joseon Red Bean Water Gel 100ml",
    "brand": "Beauty of Joseon",
    "category": "moisturisers",
    "packSize": "100ml",
    "observedAuroraGbpPence": 1550,
    "retailPricePence": 1550,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-red-bean-water-gel-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "700",
    "slug": "beauty-of-joseon-relief-sun-aqua-fresh-rice-b5-spf50-50ml",
    "name": "Beauty of Joseon Relief Sun Aqua-Fresh Rice + B5 SPF50+ 50ml",
    "brand": "Beauty of Joseon",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 1550,
    "retailPricePence": 1550,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-relief-sun-aqua-fresh-rice-b5-spf50-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "941",
    "slug": "beauty-of-joseon-relief-sun-rice-probiotics-spf50-50ml-2",
    "name": "Beauty of Joseon Relief Sun Rice + Probiotics SPF50+ 50ml",
    "brand": "Beauty of Joseon",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 1550,
    "retailPricePence": 1550,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-relief-sun-rice-probiotics-spf50-50ml-2/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "682",
    "slug": "beauty-of-joseon-revive-eye-serum-ginseng-retinal-30ml",
    "name": "Beauty of Joseon Revive Eye Serum Ginseng + Retinal 30ml",
    "brand": "Beauty of Joseon",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 1500,
    "retailPricePence": 1500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-revive-eye-serum-ginseng-retinal-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1175",
    "slug": "beauty-of-joseon-revive-serum-ginseng-snail-mucin-30ml",
    "name": "Beauty of Joseon Revive Serum Ginseng + Snail Mucin 30ml",
    "brand": "Beauty of Joseon",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 1500,
    "retailPricePence": 1500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-of-joseon-revive-serum-ginseng-snail-mucin-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1001",
    "slug": "beauty-works-10-in-1-miracle-heat-protect-spray-250ml",
    "name": "Beauty Works 10 in 1 Miracle Heat Protect Spray 250ml",
    "brand": "Beauty Works",
    "category": "hair",
    "packSize": "250ml",
    "observedAuroraGbpPence": 1399,
    "retailPricePence": 1399,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beauty-works-10-in-1-miracle-heat-protect-spray-250ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "760",
    "slug": "beautypro-eye-therapy-under-eye-mask-with-collagen-and-green-tea-extract-3-applications",
    "name": "BEAUTYPRO Eye Therapy Under Eye Mask with Collagen and Green Tea Extract (3 Applications)",
    "brand": "BEAUTYPRO",
    "category": "masks",
    "packSize": null,
    "observedAuroraGbpPence": 600,
    "retailPricePence": 600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/beautypro-eye-therapy-under-eye-mask-with-collagen-and-green-tea-extract-3-applications/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "673",
    "slug": "biodance-bio-collagen-real-deep-mask-4-pack",
    "name": "Biodance Bio Collagen-Real Deep Mask (4 Pack)",
    "brand": "Biodance",
    "category": "masks",
    "packSize": null,
    "observedAuroraGbpPence": 1490,
    "retailPricePence": 1490,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/biodance-bio-collagen-real-deep-mask-4-pack/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "499",
    "slug": "biodance-caviar-pdrn-real-deep-mask-4-pack",
    "name": "Biodance Caviar PDRN Real Deep Mask (4 Pack)",
    "brand": "Biodance",
    "category": "masks",
    "packSize": null,
    "observedAuroraGbpPence": 1490,
    "retailPricePence": 1490,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/biodance-caviar-pdrn-real-deep-mask-4-pack/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1113",
    "slug": "biodance-hydro-cera-nol-ampoule-50ml",
    "name": "Biodance Hydro Cera-nol Ampoule 50ml",
    "brand": "Biodance",
    "category": "treatments",
    "packSize": "50ml",
    "observedAuroraGbpPence": 3600,
    "retailPricePence": 3600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/biodance-hydro-cera-nol-ampoule-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "893",
    "slug": "biodance-hydro-cera-nol-real-deep-mask-4-pack",
    "name": "Biodance Hydro Cera-nol Real Deep Mask (4 Pack)",
    "brand": "Biodance",
    "category": "masks",
    "packSize": null,
    "observedAuroraGbpPence": 1490,
    "retailPricePence": 1490,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/biodance-hydro-cera-nol-real-deep-mask-4-pack/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "561",
    "slug": "biodance-pore-perfecting-collagen-peptide-serum-30ml",
    "name": "Biodance Pore Perfecting Collagen Peptide Serum 30ml",
    "brand": "Biodance",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 2300,
    "retailPricePence": 2300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/biodance-pore-perfecting-collagen-peptide-serum-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "781",
    "slug": "bobbi-brown-vitamin-enriched-face-base-50ml",
    "name": "Bobbi Brown Vitamin Enriched Face Base 50ml",
    "brand": "Bobbi Brown",
    "category": "makeup",
    "packSize": "50ml",
    "observedAuroraGbpPence": 4050,
    "retailPricePence": 4050,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/bobbi-brown-vitamin-enriched-face-base-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "730",
    "slug": "cerave-am-facial-moisturising-lotion-spf50-for-normal-to-dry-skin-52ml",
    "name": "CeraVe AM Facial Moisturising Lotion SPF50 for Normal to Dry Skin 52ml",
    "brand": "CeraVe",
    "category": "suncare",
    "packSize": "52ml",
    "observedAuroraGbpPence": 1650,
    "retailPricePence": 1650,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/cerave-am-facial-moisturising-lotion-spf50-for-normal-to-dry-skin-52ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "754",
    "slug": "cerave-blemish-control-face-cleanser-with-2-salicylic-acid-niacinamide-for-blemish-prone-skin-236ml",
    "name": "CeraVe Blemish Control Face Cleanser with 2% Salicylic Acid & Niacinamide for Blemish-Prone Skin 236ml",
    "brand": "CeraVe",
    "category": "cleansers",
    "packSize": "236ml",
    "observedAuroraGbpPence": 1450,
    "retailPricePence": 1450,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/cerave-blemish-control-face-cleanser-with-2-salicylic-acid-niacinamide-for-blemish-prone-skin-236ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "850",
    "slug": "cerave-hydrating-cleanser-with-hyaluronic-acid-for-normal-to-dry-skin-473ml",
    "name": "CeraVe Hydrating Cleanser with Hyaluronic Acid for Normal to Dry Skin 473ml",
    "brand": "CeraVe",
    "category": "cleansers",
    "packSize": "473ml",
    "observedAuroraGbpPence": 1850,
    "retailPricePence": 1850,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/cerave-hydrating-cleanser-with-hyaluronic-acid-for-normal-to-dry-skin-473ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "812",
    "slug": "cerave-pm-facial-moisturising-lotion-with-ceramides-for-normal-to-dry-skin-52ml",
    "name": "CeraVe PM Facial Moisturising Lotion with Ceramides for Normal to Dry Skin 52ml",
    "brand": "CeraVe",
    "category": "treatments",
    "packSize": "52ml",
    "observedAuroraGbpPence": 1650,
    "retailPricePence": 1650,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/cerave-pm-facial-moisturising-lotion-with-ceramides-for-normal-to-dry-skin-52ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "902",
    "slug": "cetaphil-daily-hydrating-moisturiser-88ml",
    "name": "Cetaphil Daily Hydrating Moisturiser 88ml",
    "brand": "Cetaphil",
    "category": "moisturisers",
    "packSize": "88ml",
    "observedAuroraGbpPence": 1650,
    "retailPricePence": 1650,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/cetaphil-daily-hydrating-moisturiser-88ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1251",
    "slug": "christophe-robin-cleansing-purifying-scrub-with-sea-salt-250ml",
    "name": "Christophe Robin Cleansing Purifying Scrub with Sea Salt 250ml",
    "brand": "Christophe Robin",
    "category": "hair",
    "packSize": "250ml",
    "observedAuroraGbpPence": 4300,
    "retailPricePence": 4300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/christophe-robin-cleansing-purifying-scrub-with-sea-salt-250ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "487",
    "slug": "clinique-mini-take-the-day-off-cleansing-balm-30ml",
    "name": "Clinique Mini Take the Day off Cleansing Balm 30ml",
    "brand": "Clinique",
    "category": "cleansers",
    "packSize": "30ml",
    "observedAuroraGbpPence": 1000,
    "retailPricePence": 1000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/clinique-mini-take-the-day-off-cleansing-balm-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "567",
    "slug": "clinique-moisture-surge-day-and-night-moisture-skincare-gift-set",
    "name": "Clinique Moisture Surge Day And Night Moisture Skincare Gift Set",
    "brand": "Clinique",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 5000,
    "retailPricePence": 5000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/clinique-moisture-surge-day-and-night-moisture-skincare-gift-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "835",
    "slug": "clinique-take-the-day-off-cleansing-balm-125ml",
    "name": "Clinique Take The Day Off Cleansing Balm 125ml",
    "brand": "Clinique",
    "category": "cleansers",
    "packSize": "125ml",
    "observedAuroraGbpPence": 3400,
    "retailPricePence": 3400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/clinique-take-the-day-off-cleansing-balm-125ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1254",
    "slug": "color-wow-and-chris-appleton-money-masque-215ml",
    "name": "Color Wow and Chris Appleton Money Masque 215ml",
    "brand": "Color Wow",
    "category": "hair",
    "packSize": "215ml",
    "observedAuroraGbpPence": 3950,
    "retailPricePence": 3950,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/color-wow-and-chris-appleton-money-masque-215ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1004",
    "slug": "color-wow-dream-clean-fine-to-normal-duo",
    "name": "Color Wow Dream Clean Fine to Normal Duo",
    "brand": "Color Wow",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 4300,
    "retailPricePence": 4300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/color-wow-dream-clean-fine-to-normal-duo/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "947",
    "slug": "color-wow-dream-coat-supernatural-spray-200ml",
    "name": "Color Wow Dream Coat Supernatural Spray 200ml",
    "brand": "Color Wow",
    "category": "hair",
    "packSize": "200ml",
    "observedAuroraGbpPence": 2700,
    "retailPricePence": 2700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/color-wow-dream-coat-supernatural-spray-200ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1028",
    "slug": "color-wow-money-mist-150ml",
    "name": "Color Wow Money Mist 150ml",
    "brand": "Color Wow",
    "category": "hair",
    "packSize": "150ml",
    "observedAuroraGbpPence": 2950,
    "retailPricePence": 2950,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/color-wow-money-mist-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "995",
    "slug": "color-wow-style-on-steroids-performance-enhancing-texture-finishing-spray-250ml",
    "name": "Color Wow Style on Steroids Performance Enhancing Texture + Finishing Spray 250ml",
    "brand": "Color Wow",
    "category": "hair",
    "packSize": "250ml",
    "observedAuroraGbpPence": 2800,
    "retailPricePence": 2800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/color-wow-style-on-steroids-performance-enhancing-texture-finishing-spray-250ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "998",
    "slug": "cosrx-acne-pimple-master-patch-24-patches",
    "name": "COSRX Acne Pimple Master Patch (24 Patches)",
    "brand": "COSRX",
    "category": "masks",
    "packSize": null,
    "observedAuroraGbpPence": 599,
    "retailPricePence": 599,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/cosrx-acne-pimple-master-patch-24-patches/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "401",
    "slug": "cosrx-advanced-snail-92-all-in-one-cream-100ml",
    "name": "COSRX Advanced Snail 92 All in One Cream 100g",
    "brand": "COSRX",
    "category": "moisturisers",
    "packSize": "100g",
    "observedAuroraGbpPence": 3099,
    "retailPricePence": 3099,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/cosrx-advanced-snail-92-all-in-one-cream-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1190",
    "slug": "cosrx-advanced-snail-96-mucin-power-essence-100ml",
    "name": "COSRX Advanced Snail 96 Mucin Power Essence 100ml",
    "brand": "COSRX",
    "category": "treatments",
    "packSize": "100ml",
    "observedAuroraGbpPence": 2799,
    "retailPricePence": 2799,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/cosrx-advanced-snail-96-mucin-power-essence-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "339",
    "slug": "cosrx-the-6-peptide-skin-booster-serum-150ml",
    "name": "COSRX The 6 Peptide Skin Booster Serum 150ml",
    "brand": "COSRX",
    "category": "treatments",
    "packSize": "150ml",
    "observedAuroraGbpPence": 2700,
    "retailPricePence": 2700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/cosrx-the-6-peptide-skin-booster-serum-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1205",
    "slug": "dr-jart-ceramidin-cream-50ml",
    "name": "Dr.Jart+ Ceramidin Cream 50ml",
    "brand": "Dr.Jart+",
    "category": "moisturisers",
    "packSize": "50ml",
    "observedAuroraGbpPence": 3800,
    "retailPricePence": 3800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/dr-jart-ceramidin-cream-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1159",
    "slug": "dr-jart-ceramidin-milky-lotion-50ml",
    "name": "Dr.Jart+ Ceramidin Milky Lotion 50ml",
    "brand": "Dr.Jart+",
    "category": "moisturisers",
    "packSize": "50ml",
    "observedAuroraGbpPence": 3300,
    "retailPricePence": 3300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/dr-jart-ceramidin-milky-lotion-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "975",
    "slug": "drunk-elephant-d-bronzi-bronzing-drops-30ml",
    "name": "Drunk Elephant D-Bronzi™ Bronzing Drops 30ml",
    "brand": "Drunk Elephant",
    "category": "makeup",
    "packSize": "30ml",
    "observedAuroraGbpPence": 3400,
    "retailPricePence": 3400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/drunk-elephant-d-bronzi-bronzing-drops-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "617",
    "slug": "drunk-elephant-relax-and-refill-protini-edition",
    "name": "Drunk Elephant Relax and Refill Protini Edition",
    "brand": "Drunk Elephant",
    "category": "other",
    "packSize": null,
    "observedAuroraGbpPence": 11600,
    "retailPricePence": 11600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/drunk-elephant-relax-and-refill-protini-edition/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1064",
    "slug": "elemis-pro-collagen-black-cherry-cleansing-balm-100g",
    "name": "Elemis Pro-Collagen Black Cherry Cleansing Balm 100g",
    "brand": "Elemis",
    "category": "cleansers",
    "packSize": "100g",
    "observedAuroraGbpPence": 5200,
    "retailPricePence": 5200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/elemis-pro-collagen-black-cherry-cleansing-balm-100g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "706",
    "slug": "elemis-pro-collagen-cleansing-balm-100g",
    "name": "Elemis Pro-Collagen Cleansing Balm 100g",
    "brand": "Elemis",
    "category": "cleansers",
    "packSize": "100g",
    "observedAuroraGbpPence": 5200,
    "retailPricePence": 5200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/elemis-pro-collagen-cleansing-balm-100g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "790",
    "slug": "elemis-pro-collagen-marine-cream-spf-30-50ml",
    "name": "Elemis Pro-Collagen Marine Cream SPF 30 50ml",
    "brand": "Elemis",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 9800,
    "retailPricePence": 9800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/elemis-pro-collagen-marine-cream-spf-30-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "574",
    "slug": "elemis-superfood-essentials-routine",
    "name": "Elemis Superfood Essentials Routine",
    "brand": "Elemis",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 5400,
    "retailPricePence": 5400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/elemis-superfood-essentials-routine/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "830",
    "slug": "elemis-superfood-midnight-facial-50ml",
    "name": "Elemis Superfood Midnight Facial 50ml",
    "brand": "Elemis",
    "category": "treatments",
    "packSize": "50ml",
    "observedAuroraGbpPence": 1250,
    "retailPricePence": 1250,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/elemis-superfood-midnight-facial-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "745",
    "slug": "embryolisse-lait-creme-concentre-multi-purpose-moisturiser-75ml",
    "name": "Embryolisse Lait-Crème Concentré Multi-Purpose Moisturiser 75ml",
    "brand": "Embryolisse",
    "category": "moisturisers",
    "packSize": "75ml",
    "observedAuroraGbpPence": 2199,
    "retailPricePence": 2199,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/embryolisse-lait-creme-concentre-multi-purpose-moisturiser-75ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1178",
    "slug": "erborian-cc-red-correct-15ml",
    "name": "Erborian CC Red Correct 15ml",
    "brand": "Erborian",
    "category": "makeup",
    "packSize": "15ml",
    "observedAuroraGbpPence": 1900,
    "retailPricePence": 1900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/erborian-cc-red-correct-15ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1208",
    "slug": "erborian-cc-red-correct-40ml",
    "name": "Erborian CC Red Correct 40ml",
    "brand": "Erborian",
    "category": "makeup",
    "packSize": "40ml",
    "observedAuroraGbpPence": 3800,
    "retailPricePence": 3800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/erborian-cc-red-correct-40ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "348",
    "slug": "anua-double-cleansing-duo-bundle",
    "name": "Erborian Centella Cleansing Oil – 180ml",
    "brand": "Erborian",
    "category": "cleansers",
    "packSize": "180ml",
    "observedAuroraGbpPence": 2200,
    "retailPricePence": 2200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/anua-double-cleansing-duo-bundle/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "636",
    "slug": "estee-lauder-advanced-night-repair-synchronized-multi-recovery-complex-serum-1-oz-30ml",
    "name": "Estée Lauder Advanced Night Repair Synchronized Multi-Recovery Complex Serum – 1 oz/30ml",
    "brand": "Estée Lauder",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 6500,
    "retailPricePence": 6500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/estee-lauder-advanced-night-repair-synchronized-multi-recovery-complex-serum-1-oz-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "614",
    "slug": "estee-lauder-the-complexion-prep-gift-set",
    "name": "Estée Lauder The Complexion Prep Gift Set",
    "brand": "Estée Lauder",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 13600,
    "retailPricePence": 13600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/estee-lauder-the-complexion-prep-gift-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1153",
    "slug": "exclusive-beauty-of-joseon-calming-serum-green-tea-panthenol-jumbo-size-60ml",
    "name": "Exclusive Beauty of Joseon Calming Serum Green Tea + Panthenol Jumbo Size 60ml",
    "brand": "Beauty of Joseon",
    "category": "treatments",
    "packSize": "60ml",
    "observedAuroraGbpPence": 2700,
    "retailPricePence": 2700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/exclusive-beauty-of-joseon-calming-serum-green-tea-panthenol-jumbo-size-60ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "549",
    "slug": "exclusive-clinique-moisture-surge-hydration-skin-heroes-set",
    "name": "EXCLUSIVE Clinique Moisture Surge Hydration Skin Heroes Set",
    "brand": "Clinique",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 12500,
    "retailPricePence": 12500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/exclusive-clinique-moisture-surge-hydration-skin-heroes-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1076",
    "slug": "eylure-dybrow-brow-dye-dark-brown",
    "name": "Eylure Dybrow Brow Dye – Dark Brown",
    "brand": "Eylure",
    "category": "makeup",
    "packSize": null,
    "observedAuroraGbpPence": 875,
    "retailPricePence": 875,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/eylure-dybrow-brow-dye-dark-brown/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "955",
    "slug": "fenty-beauty-mini-grip-trip-hydrating-primer-15ml",
    "name": "Fenty Beauty Mini Grip Trip Hydrating Primer 15ml",
    "brand": "Fenty Beauty",
    "category": "makeup",
    "packSize": "15ml",
    "observedAuroraGbpPence": 1600,
    "retailPricePence": 1600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/fenty-beauty-mini-grip-trip-hydrating-primer-15ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "534",
    "slug": "fenty-skin-dew-n-plump-hydrating-slushie-face-mask-75g",
    "name": "Fenty Skin Dew N Plump Hydrating Slushie Face Mask, 75g",
    "brand": "Fenty Skin",
    "category": "masks",
    "packSize": "75g",
    "observedAuroraGbpPence": 2800,
    "retailPricePence": 2800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/fenty-skin-dew-n-plump-hydrating-slushie-face-mask-75g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "866",
    "slug": "garnier-micellar-water-facial-cleanser-and-makeup-remover-for-sensitive-skin-700ml",
    "name": "Garnier Micellar Water Facial Cleanser and Makeup Remover for Sensitive Skin 700ml",
    "brand": "Garnier",
    "category": "makeup",
    "packSize": "700ml",
    "observedAuroraGbpPence": 999,
    "retailPricePence": 999,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/garnier-micellar-water-facial-cleanser-and-makeup-remover-for-sensitive-skin-700ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1266",
    "slug": "haruharu-wonder-black-rice-bakuchiol-eye-cream-20ml",
    "name": "Haruharu Wonder Black Rice Bakuchiol Eye Cream 20ml",
    "brand": "Haruharu Wonder",
    "category": "treatments",
    "packSize": "20ml",
    "observedAuroraGbpPence": 1600,
    "retailPricePence": 1600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/haruharu-wonder-black-rice-bakuchiol-eye-cream-20ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1217",
    "slug": "haruharu-wonder-black-rice-moisture-5-5-soft-cleansing-gel-100ml",
    "name": "Haruharu Wonder Black Rice Moisture 5.5 Soft Cleansing Gel 100ml",
    "brand": "Haruharu Wonder",
    "category": "cleansers",
    "packSize": "100ml",
    "observedAuroraGbpPence": 1400,
    "retailPricePence": 1400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/haruharu-wonder-black-rice-moisture-5-5-soft-cleansing-gel-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1263",
    "slug": "haruharu-wonder-black-rice-moisture-airyfit-daily-sunscreen-spf50-pa-50ml",
    "name": "Haruharu Wonder Black Rice Moisture Airyfit Daily Sunscreen SPF50+/PA++++ 50ml",
    "brand": "Haruharu Wonder",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 1700,
    "retailPricePence": 1700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/haruharu-wonder-black-rice-moisture-airyfit-daily-sunscreen-spf50-pa-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1096",
    "slug": "haruharu-wonder-black-rice-moisture-deep-cleansing-oil-150ml",
    "name": "Haruharu Wonder Black Rice Moisture Deep Cleansing Oil 150ml",
    "brand": "Haruharu Wonder",
    "category": "cleansers",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1900,
    "retailPricePence": 1900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/haruharu-wonder-black-rice-moisture-deep-cleansing-oil-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1172",
    "slug": "haruharu-wonder-black-rice-probiotics-barrier-essence-120ml",
    "name": "Haruharu Wonder Black Rice Probiotics Barrier Essence 120ml",
    "brand": "Haruharu Wonder",
    "category": "treatments",
    "packSize": "120ml",
    "observedAuroraGbpPence": 2100,
    "retailPricePence": 2100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/haruharu-wonder-black-rice-probiotics-barrier-essence-120ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1042",
    "slug": "iconic-london-underglow-blurring-primer-27ml",
    "name": "ICONIC London Underglow Blurring Primer 27ml",
    "brand": "ICONIC London",
    "category": "makeup",
    "packSize": "27ml",
    "observedAuroraGbpPence": 2500,
    "retailPricePence": 2500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/iconic-london-underglow-blurring-primer-27ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1135",
    "slug": "innisfree-green-tea-seed-hyaluronic-serum-80ml",
    "name": "INNISFREE Green Tea Seed Hyaluronic Serum 80ml",
    "brand": "INNISFREE",
    "category": "treatments",
    "packSize": "80ml",
    "observedAuroraGbpPence": 2500,
    "retailPricePence": 2500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/innisfree-green-tea-seed-hyaluronic-serum-80ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "663",
    "slug": "innisfree-hydrate-and-protect-set",
    "name": "INNISFREE Hydrate and Protect Set",
    "brand": "INNISFREE",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 3300,
    "retailPricePence": 3300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/innisfree-hydrate-and-protect-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1144",
    "slug": "isntree-hyaluronic-acid-watery-sun-gel-spf50-pa-50ml",
    "name": "Isntree Hyaluronic Acid Watery Sun Gel SPF50+ PA++++ 50ml",
    "brand": "Isntree",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 2300,
    "retailPricePence": 2300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/isntree-hyaluronic-acid-watery-sun-gel-spf50-pa-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "938",
    "slug": "kerastase-genesis-hair-serum-leave-in-conditioner-for-hair-fall-with-caffeine-anti-chute-fortifiant-90ml",
    "name": "Kérastase Genesis Hair Serum, Leave-In Conditioner, For Hair Fall, With Caffeine, Anti-Chute Fortifiant, 90ml",
    "brand": "Kérastase",
    "category": "hair",
    "packSize": "90ml",
    "observedAuroraGbpPence": 5200,
    "retailPricePence": 5200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/kerastase-genesis-hair-serum-leave-in-conditioner-for-hair-fall-with-caffeine-anti-chute-fortifiant-90ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "969",
    "slug": "kerastase-gloss-absolu-glaze-drops-hair-oil-with-wild-rose-45ml",
    "name": "Kérastase Gloss Absolu Glaze Drops Hair Oil with Wild Rose 45ml",
    "brand": "Kérastase",
    "category": "hair",
    "packSize": "45ml",
    "observedAuroraGbpPence": 4000,
    "retailPricePence": 4000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/kerastase-gloss-absolu-glaze-drops-hair-oil-with-wild-rose-45ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "952",
    "slug": "kerastase-gloss-absolu-shampoo-and-conditioner-duo-with-glycolic-acid-hyaluronic-acid-and-wild-rose",
    "name": "Kérastase Gloss Absolu Shampoo and Conditioner Duo, with Glycolic Acid, Hyaluronic Acid and Wild Rose",
    "brand": "Kérastase",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 6750,
    "retailPricePence": 6750,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/kerastase-gloss-absolu-shampoo-and-conditioner-duo-with-glycolic-acid-hyaluronic-acid-and-wild-rose/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "703",
    "slug": "kiehls-creamy-eye-treatment-with-avocado-14g",
    "name": "Kiehl’s Creamy Eye Treatment with Avocado – 14g",
    "brand": "Kiehl’s",
    "category": "treatments",
    "packSize": "14g",
    "observedAuroraGbpPence": 3000,
    "retailPricePence": 3000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/kiehls-creamy-eye-treatment-with-avocado-14g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "577",
    "slug": "kiehls-moisturising-minis",
    "name": "Kiehl’s Moisturising Minis",
    "brand": "Kiehl’s",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 3900,
    "retailPricePence": 3900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/kiehls-moisturising-minis/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "626",
    "slug": "kiehls-smooth-it-up-set",
    "name": "Kiehl’s Smooth It Up Set",
    "brand": "Kiehl’s",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 5100,
    "retailPricePence": 5100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/kiehls-smooth-it-up-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "639",
    "slug": "kiehls-ultra-facial-cream-28ml",
    "name": "Kiehls Ultra Facial Cream 28ml",
    "brand": "Kiehl’s",
    "category": "treatments",
    "packSize": "28ml",
    "observedAuroraGbpPence": 2100,
    "retailPricePence": 2100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/kiehls-ultra-facial-cream-28ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "586",
    "slug": "kylie-cosmic-intense-eau-de-parfum-100ml",
    "name": "Kylie Cosmic Intense Eau de Parfum 100ml",
    "brand": "Kylie",
    "category": "fragrance",
    "packSize": "100ml",
    "observedAuroraGbpPence": 6000,
    "retailPricePence": 6000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/kylie-cosmic-intense-eau-de-parfum-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "978",
    "slug": "loccitane-almond-shower-oil-500ml",
    "name": "L’Occitane Almond Shower Oil 500ml",
    "brand": "L’Occitane",
    "category": "body-care",
    "packSize": "500ml",
    "observedAuroraGbpPence": 3950,
    "retailPricePence": 3950,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/loccitane-almond-shower-oil-500ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "958",
    "slug": "loccitane-shea-karite-hand-cream-150ml",
    "name": "L’Occitane Shea (Karité) Hand Cream 150ml",
    "brand": "L’Occitane",
    "category": "body-care",
    "packSize": "150ml",
    "observedAuroraGbpPence": 2700,
    "retailPricePence": 2700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/loccitane-shea-karite-hand-cream-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "801",
    "slug": "loreal-paris-revitalift-filler-glass-skin-liquid-cream-face-moisturiser-50ml-2",
    "name": "L’Oréal Paris Revitalift Filler Glass Skin Liquid Cream Face Moisturiser, 50ml",
    "brand": "L’Oréal Paris",
    "category": "moisturisers",
    "packSize": "50ml",
    "observedAuroraGbpPence": 1799,
    "retailPricePence": 1799,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/loreal-paris-revitalift-filler-glass-skin-liquid-cream-face-moisturiser-50ml-2/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "648",
    "slug": "la-roche-posay-anti-blemish-evening-routine-effaclar-cleanser-treatment-patches",
    "name": "La Roche Posay Anti-Blemish Evening Routine Effaclar Cleanser, Treatment & Patches",
    "brand": "La Roche-Posay",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 5330,
    "retailPricePence": 5330,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-anti-blemish-evening-routine-effaclar-cleanser-treatment-patches/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "522",
    "slug": "la-roche-posay-toleriane-dermo-cleanser-for-sensitive-skin-400ml",
    "name": "La Roche Posay Toleriane Dermo Cleanser for Sensitive Skin 400ml",
    "brand": "La Roche-Posay",
    "category": "cleansers",
    "packSize": "400ml",
    "observedAuroraGbpPence": 2350,
    "retailPricePence": 2350,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-toleriane-dermo-cleanser-for-sensitive-skin-400ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "882",
    "slug": "la-roche-posay-anthelios-oil-control-fluid-spf50-for-oily-blemish-prone-skin-50ml",
    "name": "La Roche-Posay Anthelios Oil Control Fluid SPF50+ for Oily Blemish-Prone Skin 50ml",
    "brand": "La Roche-Posay",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 2100,
    "retailPricePence": 2100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-anthelios-oil-control-fluid-spf50-for-oily-blemish-prone-skin-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "687",
    "slug": "la-roche-posay-anthelios-uvmune-400-invisible-fluid-non-perfumed-suncream-spf50-50ml",
    "name": "La Roche-Posay Anthelios UVMune 400 Invisible Fluid Non-Perfumed Suncream SPF50+ 50ml",
    "brand": "La Roche-Posay",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 2000,
    "retailPricePence": 2000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-anthelios-uvmune-400-invisible-fluid-non-perfumed-suncream-spf50-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "844",
    "slug": "la-roche-posay-cicaplast-b5-anti-bacterial-cleansing-gel-wash-200ml",
    "name": "La Roche-Posay Cicaplast B5 Anti-Bacterial Cleansing Gel Wash 200ml",
    "brand": "La Roche-Posay",
    "category": "cleansers",
    "packSize": "200ml",
    "observedAuroraGbpPence": 1650,
    "retailPricePence": 1650,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-cicaplast-b5-anti-bacterial-cleansing-gel-wash-200ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "669",
    "slug": "la-roche-posay-cicaplast-balm-b5-multi-purpose-repairing-balm-100ml",
    "name": "La Roche-Posay Cicaplast Balm B5 Multi-Purpose Repairing Balm 100ml",
    "brand": "La Roche-Posay",
    "category": "moisturisers",
    "packSize": "100ml",
    "observedAuroraGbpPence": 1950,
    "retailPricePence": 1950,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-cicaplast-balm-b5-multi-purpose-repairing-balm-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "694",
    "slug": "la-roche-posay-cicaplast-balm-b5-multi-purpose-repairing-balm-40ml",
    "name": "La Roche-Posay Cicaplast Balm B5 Multi-Purpose Repairing Balm 40ml",
    "brand": "La Roche-Posay",
    "category": "moisturisers",
    "packSize": "40ml",
    "observedAuroraGbpPence": 1100,
    "retailPricePence": 1100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-cicaplast-balm-b5-multi-purpose-repairing-balm-40ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "905",
    "slug": "la-roche-posay-cicaplast-baume-lips-7-5ml",
    "name": "La Roche-Posay Cicaplast Baume Lips 7.5ml",
    "brand": "La Roche-Posay",
    "category": "moisturisers",
    "packSize": "7.5ml",
    "observedAuroraGbpPence": 850,
    "retailPricePence": 850,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-cicaplast-baume-lips-7-5ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "827",
    "slug": "la-roche-posay-cicaplast-repairing-baume-b5-spf50-for-irritated-skin-40ml",
    "name": "La Roche-Posay Cicaplast Repairing Baume B5+ SPF50 For Irritated Skin 40ml",
    "brand": "La Roche-Posay",
    "category": "suncare",
    "packSize": "40ml",
    "observedAuroraGbpPence": 1250,
    "retailPricePence": 1250,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-cicaplast-repairing-baume-b5-spf50-for-irritated-skin-40ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "772",
    "slug": "la-roche-posay-effaclar-duom-anti-blemish-corrective-gel-moisturiser-for-oily-blemish-prone-skin-40ml",
    "name": "La Roche-Posay Effaclar Duo+M Anti-Blemish Corrective Gel Moisturiser for Oily, Blemish-Prone Skin 40ml",
    "brand": "La Roche-Posay",
    "category": "moisturisers",
    "packSize": "40ml",
    "observedAuroraGbpPence": 2090,
    "retailPricePence": 2090,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-effaclar-duom-anti-blemish-corrective-gel-moisturiser-for-oily-blemish-prone-skin-40ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1019",
    "slug": "la-roche-posay-effaclar-purifying-foaming-gel-cleanser-for-oily-blemish-prone-skin-400ml-2",
    "name": "La Roche-Posay Effaclar Purifying Foaming Gel Cleanser for Oily, Blemish-Prone Skin 400ml",
    "brand": "La Roche-Posay",
    "category": "cleansers",
    "packSize": "400ml",
    "observedAuroraGbpPence": 2450,
    "retailPricePence": 2450,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-effaclar-purifying-foaming-gel-cleanser-for-oily-blemish-prone-skin-400ml-2/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "838",
    "slug": "la-roche-posay-hyalu-b5-suractivated-serum-30ml",
    "name": "La Roche-Posay Hyalu B5 Suractivated Serum 30ml",
    "brand": "La Roche-Posay",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 4500,
    "retailPricePence": 4500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-hyalu-b5-suractivated-serum-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "793",
    "slug": "la-roche-posay-lipikar-apmax-triple-action-balm-for-ultra-dry-to-atopic-eczema-prone-skin-400ml",
    "name": "La Roche-Posay LIPIKAR AP+Max Triple-Action Balm for Ultra-Dry to Atopic Eczema-Prone Skin 400ml",
    "brand": "La Roche-Posay",
    "category": "moisturisers",
    "packSize": "400ml",
    "observedAuroraGbpPence": 2500,
    "retailPricePence": 2500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-lipikar-apmax-triple-action-balm-for-ultra-dry-to-atopic-eczema-prone-skin-400ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "724",
    "slug": "la-roche-posay-toleriane-respectissime-waterproof-eye-make-up-remover-125ml",
    "name": "La Roche-Posay Toleriane Respectissime Waterproof Eye Make-Up Remover 125ml",
    "brand": "La Roche-Posay",
    "category": "cleansers",
    "packSize": "125ml",
    "observedAuroraGbpPence": 1300,
    "retailPricePence": 1300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/la-roche-posay-toleriane-respectissime-waterproof-eye-make-up-remover-125ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "525",
    "slug": "laneige-berry-sweet-lip-trio-set",
    "name": "Laneige Berry Sweet Lip Trio Set",
    "brand": "LANEIGE",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 2900,
    "retailPricePence": 2900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-berry-sweet-lip-trio-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1132",
    "slug": "laneige-bouncy-firm-serum-30ml",
    "name": "LANEIGE Bouncy & Firm Serum 30ml",
    "brand": "LANEIGE",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 3900,
    "retailPricePence": 3900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-bouncy-firm-serum-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1229",
    "slug": "laneige-bouncy-and-firm-sleeping-mask-60ml",
    "name": "LANEIGE Bouncy and Firm Sleeping Mask 60ml",
    "brand": "LANEIGE",
    "category": "masks",
    "packSize": "60ml",
    "observedAuroraGbpPence": 3200,
    "retailPricePence": 3200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-bouncy-and-firm-sleeping-mask-60ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "528",
    "slug": "laneige-bouncy-skin-on-the-go-set",
    "name": "Laneige Bouncy Skin on the go Set",
    "brand": "LANEIGE",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 3900,
    "retailPricePence": 3900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-bouncy-skin-on-the-go-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1187",
    "slug": "laneige-cream-skin-cerapeptide-toner-and-moisturiser-170ml",
    "name": "LANEIGE Cream Skin Cerapeptide Toner and Moisturiser 170ml",
    "brand": "LANEIGE",
    "category": "treatments",
    "packSize": "170ml",
    "observedAuroraGbpPence": 2950,
    "retailPricePence": 2950,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-cream-skin-cerapeptide-toner-and-moisturiser-170ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "513",
    "slug": "laneige-daily-hydration-essential-set",
    "name": "Laneige Daily Hydration Essential Set",
    "brand": "LANEIGE",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 2900,
    "retailPricePence": 2900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-daily-hydration-essential-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "531",
    "slug": "laneige-donut-delight-lip-serum-duo-set",
    "name": "Laneige Donut Delight Lip Serum Duo Set",
    "brand": "LANEIGE",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 3300,
    "retailPricePence": 3300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-donut-delight-lip-serum-duo-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1117",
    "slug": "laneige-hydro-uv-defence-ex-spf-50-50ml",
    "name": "LANEIGE Hydro UV Defence EX SPF 50 50ml",
    "brand": "LANEIGE",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 2600,
    "retailPricePence": 2600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-hydro-uv-defence-ex-spf-50-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1037",
    "slug": "laneige-icons-to-go-set",
    "name": "LANEIGE Icons To Go Set",
    "brand": "LANEIGE",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 2300,
    "retailPricePence": 2300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-icons-to-go-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1062",
    "slug": "laneige-lip-glowy-balm-berry-10g",
    "name": "LANEIGE Lip Glowy Balm – Berry 10g",
    "brand": "LANEIGE",
    "category": "makeup",
    "packSize": "10g",
    "observedAuroraGbpPence": 1750,
    "retailPricePence": 1750,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-lip-glowy-balm-berry-10g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1202",
    "slug": "laneige-lip-glowy-balm-vanilla-10g",
    "name": "LANEIGE Lip Glowy Balm – Vanilla 10g",
    "brand": "LANEIGE",
    "category": "makeup",
    "packSize": "10g",
    "observedAuroraGbpPence": 1750,
    "retailPricePence": 1750,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-lip-glowy-balm-vanilla-10g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1123",
    "slug": "laneige-lip-glowy-balm-matcha-bubble-tea-10g",
    "name": "LANEIGE Lip Glowy Balm Matcha Bubble Tea 10g",
    "brand": "LANEIGE",
    "category": "makeup",
    "packSize": "10g",
    "observedAuroraGbpPence": 1750,
    "retailPricePence": 1750,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-lip-glowy-balm-matcha-bubble-tea-10g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "824",
    "slug": "laneige-lip-sleeping-mask-berry-original-20g",
    "name": "LANEIGE Lip Sleeping Mask – Berry (Original) 20g",
    "brand": "LANEIGE",
    "category": "makeup",
    "packSize": "20g",
    "observedAuroraGbpPence": 2100,
    "retailPricePence": 2100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-lip-sleeping-mask-berry-original-20g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1059",
    "slug": "laneige-lip-sleeping-mask-vanilla-20g",
    "name": "LANEIGE Lip Sleeping Mask – Vanilla 20g",
    "brand": "LANEIGE",
    "category": "makeup",
    "packSize": "20g",
    "observedAuroraGbpPence": 2100,
    "retailPricePence": 2100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-lip-sleeping-mask-vanilla-20g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1141",
    "slug": "laneige-lip-sleeping-mask-matcha-bubble-tea-20g",
    "name": "LANEIGE Lip Sleeping Mask Matcha Bubble Tea 20g",
    "brand": "LANEIGE",
    "category": "makeup",
    "packSize": "20g",
    "observedAuroraGbpPence": 2100,
    "retailPricePence": 2100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-lip-sleeping-mask-matcha-bubble-tea-20g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "537",
    "slug": "laneige-water-bank-aqua-facial-30ml",
    "name": "LANEIGE Water Bank Aqua Facial 30ml",
    "brand": "LANEIGE",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 3300,
    "retailPricePence": 3300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-water-bank-aqua-facial-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "944",
    "slug": "laneige-water-bank-blue-hyaluronic-acid-cream-moisturiser-50ml",
    "name": "LANEIGE Water Bank Blue Hyaluronic Acid Cream Moisturiser 50ml",
    "brand": "LANEIGE",
    "category": "treatments",
    "packSize": "50ml",
    "observedAuroraGbpPence": 3350,
    "retailPricePence": 3350,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-water-bank-blue-hyaluronic-acid-cream-moisturiser-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1211",
    "slug": "laneige-water-bank-gentle-gel-cleanser-250ml",
    "name": "LANEIGE Water Bank Gentle Gel Cleanser 250ml",
    "brand": "LANEIGE",
    "category": "cleansers",
    "packSize": "250ml",
    "observedAuroraGbpPence": 2500,
    "retailPricePence": 2500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-water-bank-gentle-gel-cleanser-250ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "436",
    "slug": "laneige-water-sleeping-mask-70ml",
    "name": "LANEIGE Water Sleeping Mask 70ml",
    "brand": "LANEIGE",
    "category": "masks",
    "packSize": "70ml",
    "observedAuroraGbpPence": 2800,
    "retailPricePence": 2800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/laneige-water-sleeping-mask-70ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1051",
    "slug": "living-proof-perfect-hair-day-phd-advanced-clean-dry-shampoo-198ml",
    "name": "Living Proof Perfect Hair Day (PhD) Advanced Clean Dry Shampoo 198ml",
    "brand": "Living Proof",
    "category": "hair",
    "packSize": "198ml",
    "observedAuroraGbpPence": 2700,
    "retailPricePence": 2700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/living-proof-perfect-hair-day-phd-advanced-clean-dry-shampoo-198ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1257",
    "slug": "matrix-food-for-soft-hydrating-300ml-shampoo-and-conditioner-with-avocado-oil-and-hyaluronic-acid-for-dry-hair-duo",
    "name": "Matrix Food for Soft Hydrating 300ml Shampoo and Conditioner with Avocado Oil and Hyaluronic Acid for Dry Hair Duo",
    "brand": "Matrix",
    "category": "sets",
    "packSize": "300ml",
    "observedAuroraGbpPence": 3200,
    "retailPricePence": 3200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/matrix-food-for-soft-hydrating-300ml-shampoo-and-conditioner-with-avocado-oil-and-hyaluronic-acid-for-dry-hair-duo/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "986",
    "slug": "maybelline-lash-sensational-sky-high-mascara-01-black-7-2ml",
    "name": "Maybelline Lash Sensational Sky High Mascara – 01 Black 7.2ml",
    "brand": "Maybelline",
    "category": "makeup",
    "packSize": "7.2ml",
    "observedAuroraGbpPence": 1299,
    "retailPricePence": 1299,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/maybelline-lash-sensational-sky-high-mascara-01-black-7-2ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1162",
    "slug": "medicube-age-r-led-booster-pro-black",
    "name": "Medicube Age-r LED Booster Pro Black",
    "brand": "Medicube",
    "category": "devices",
    "packSize": null,
    "observedAuroraGbpPence": 28900,
    "retailPricePence": 28900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-age-r-led-booster-pro-black/",
    "likelyBundle": false,
    "needsElectricalReview": true
  },
  {
    "auroraId": "657",
    "slug": "medicube-age-r-led-booster-pro-pink",
    "name": "Medicube Age-r LED Booster Pro Pink",
    "brand": "Medicube",
    "category": "devices",
    "packSize": null,
    "observedAuroraGbpPence": 28900,
    "retailPricePence": 28900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-age-r-led-booster-pro-pink/",
    "likelyBundle": false,
    "needsElectricalReview": true
  },
  {
    "auroraId": "1045",
    "slug": "medicube-collagen-jelly-cream-110ml",
    "name": "Medicube Collagen Jelly Cream 110ml",
    "brand": "Medicube",
    "category": "moisturisers",
    "packSize": "110ml",
    "observedAuroraGbpPence": 2600,
    "retailPricePence": 2600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-collagen-jelly-cream-110ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "727",
    "slug": "medicube-collagen-night-wrapping-mask-75ml",
    "name": "Medicube Collagen Night Wrapping Mask 75ml",
    "brand": "Medicube",
    "category": "masks",
    "packSize": "75ml",
    "observedAuroraGbpPence": 2600,
    "retailPricePence": 2600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-collagen-night-wrapping-mask-75ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1165",
    "slug": "medicube-collagen-routine",
    "name": "Medicube Collagen Routine",
    "brand": "Medicube",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 6250,
    "retailPricePence": 6250,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-collagen-routine/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1069",
    "slug": "medicube-deep-vita-c-capsule-cream-55g",
    "name": "Medicube Deep Vita C Capsule Cream 55g",
    "brand": "Medicube",
    "category": "moisturisers",
    "packSize": "55g",
    "observedAuroraGbpPence": 2600,
    "retailPricePence": 2600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-deep-vita-c-capsule-cream-55g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1093",
    "slug": "medicube-kojic-acid-turmeric-brightening-gel-mask28g4pcs",
    "name": "Medicube Kojic Acid Turmeric Brightening Gel Mask(28g*4Pcs)",
    "brand": "Medicube",
    "category": "masks",
    "packSize": "28g",
    "observedAuroraGbpPence": 2600,
    "retailPricePence": 2600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-kojic-acid-turmeric-brightening-gel-mask28g4pcs/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1220",
    "slug": "medicube-one-day-exosome-shot-pore-ampoule-7500-30ml",
    "name": "Medicube One Day Exosome Shot Pore Ampoule 7500 30ml",
    "brand": "Medicube",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 2500,
    "retailPricePence": 2500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-one-day-exosome-shot-pore-ampoule-7500-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "507",
    "slug": "medicube-pdrn-pink-collagen-capsule-cream-55g",
    "name": "Medicube PDRN Pink Collagen Capsule Cream 55g",
    "brand": "Medicube",
    "category": "moisturisers",
    "packSize": "55g",
    "observedAuroraGbpPence": 2600,
    "retailPricePence": 2600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-pdrn-pink-collagen-capsule-cream-55g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "490",
    "slug": "medicube-pdrn-pink-collagen-gel-mask-4ea",
    "name": "Medicube PDRN Pink Collagen Gel Mask 4EA",
    "brand": "Medicube",
    "category": "masks",
    "packSize": null,
    "observedAuroraGbpPence": 2600,
    "retailPricePence": 2600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-pdrn-pink-collagen-gel-mask-4ea/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "519",
    "slug": "medicube-pdrn-pink-peptide-serum-30ml",
    "name": "Medicube PDRN Pink Peptide Serum 30ml",
    "brand": "Medicube",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 2400,
    "retailPricePence": 2400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-pdrn-pink-peptide-serum-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1181",
    "slug": "medicube-triple-collagen-cream-4-0-50ml",
    "name": "Medicube Triple Collagen Cream 4.0 50ml",
    "brand": "Medicube",
    "category": "moisturisers",
    "packSize": "50ml",
    "observedAuroraGbpPence": 2600,
    "retailPricePence": 2600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-triple-collagen-cream-4-0-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1079",
    "slug": "medicube-triple-collagen-serum-4-0-55ml",
    "name": "Medicube Triple Collagen Serum 4.0 55ml",
    "brand": "Medicube",
    "category": "treatments",
    "packSize": "55ml",
    "observedAuroraGbpPence": 2300,
    "retailPricePence": 2300,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-triple-collagen-serum-4-0-55ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "679",
    "slug": "medicube-zero-pore-pad-2-0",
    "name": "Medicube Zero Pore Pad 2.0",
    "brand": "Medicube",
    "category": "treatments",
    "packSize": null,
    "observedAuroraGbpPence": 2400,
    "retailPricePence": 2400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-zero-pore-pad-2-0/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "784",
    "slug": "medicube-zero-pore-pad-mild-70pcs",
    "name": "Medicube Zero Pore Pad Mild (70Pcs)",
    "brand": "Medicube",
    "category": "treatments",
    "packSize": null,
    "observedAuroraGbpPence": 2400,
    "retailPricePence": 2400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medicube-zero-pore-pad-mild-70pcs/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "877",
    "slug": "medik8-advanced-night-restore-50ml",
    "name": "Medik8 Advanced Night Restore 50ml",
    "brand": "Medik8",
    "category": "moisturisers",
    "packSize": "50ml",
    "observedAuroraGbpPence": 6000,
    "retailPricePence": 6000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medik8-advanced-night-restore-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "645",
    "slug": "medik8-hydr8-b5-intense-30ml",
    "name": "Medik8 Hydr8 B5 Intense 30ml",
    "brand": "Medik8",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 6000,
    "retailPricePence": 6000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medik8-hydr8-b5-intense-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "654",
    "slug": "medik8-hydration-heros",
    "name": "Medik8 Hydration Heros",
    "brand": "Medik8",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 3000,
    "retailPricePence": 3000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medik8-hydration-heros/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "496",
    "slug": "medik8-niacinamide-peptides-30ml",
    "name": "Medik8 Niacinamide Peptides 30ml",
    "brand": "Medik8",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 4900,
    "retailPricePence": 4900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medik8-niacinamide-peptides-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "570",
    "slug": "medik8-peptide-boosters-set",
    "name": "Medik8 Peptide Boosters Set",
    "brand": "Medik8",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 8500,
    "retailPricePence": 8500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medik8-peptide-boosters-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "972",
    "slug": "medik8-vitamin-c-tetra-serum-30ml-2",
    "name": "Medik8 Vitamin C Tetra Serum 30ml",
    "brand": "Medik8",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 4500,
    "retailPricePence": 4500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/medik8-vitamin-c-tetra-serum-30ml-2/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1156",
    "slug": "mixsoon-bean-essence-50ml",
    "name": "Mixsoon Bean Essence 50ml",
    "brand": "Mixsoon",
    "category": "treatments",
    "packSize": "50ml",
    "observedAuroraGbpPence": 2800,
    "retailPricePence": 2800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/mixsoon-bean-essence-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "961",
    "slug": "morphe-portrait-mode-5-piece-face-brush-set",
    "name": "Morphe Portrait Mode 5-Piece Face Brush Set",
    "brand": "Morphe",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 3000,
    "retailPricePence": 3000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/morphe-portrait-mode-5-piece-face-brush-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "516",
    "slug": "murad-lipid-enriched-double-cleansing-balm-50ml",
    "name": "Murad Lipid-Enriched Double Cleansing Balm 50ml",
    "brand": "Murad",
    "category": "cleansers",
    "packSize": "50ml",
    "observedAuroraGbpPence": 3500,
    "retailPricePence": 3500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/murad-lipid-enriched-double-cleansing-balm-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "605",
    "slug": "nanobrow-eyebrow-serum-5ml",
    "name": "Nanobrow Eyebrow Serum 5ml",
    "brand": "Nanobrow",
    "category": "treatments",
    "packSize": "5ml",
    "observedAuroraGbpPence": 4600,
    "retailPricePence": 4600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/nanobrow-eyebrow-serum-5ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1022",
    "slug": "nanolash-eyelash-serum-3ml",
    "name": "Nanolash Eyelash Serum 3ml",
    "brand": "Nanolash",
    "category": "treatments",
    "packSize": "3ml",
    "observedAuroraGbpPence": 3900,
    "retailPricePence": 3900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/nanolash-eyelash-serum-3ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "608",
    "slug": "nuface-mini-starter-kit-sandy-rose",
    "name": "NuFACE Mini+ Starter Kit – Sandy Rose",
    "brand": "NuFACE",
    "category": "devices",
    "packSize": null,
    "observedAuroraGbpPence": 24400,
    "retailPricePence": 24400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/nuface-mini-starter-kit-sandy-rose/",
    "likelyBundle": false,
    "needsElectricalReview": true
  },
  {
    "auroraId": "1034",
    "slug": "olaplex-no-3-hair-perfector-pre-shampoo-strengthening-and-reparative-hair-treatment-100ml",
    "name": "Olaplex No. 3 Hair Perfector Pre-Shampoo Strengthening and Reparative Hair Treatment 100ml",
    "brand": "Olaplex",
    "category": "hair",
    "packSize": "100ml",
    "observedAuroraGbpPence": 3200,
    "retailPricePence": 3200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/olaplex-no-3-hair-perfector-pre-shampoo-strengthening-and-reparative-hair-treatment-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "543",
    "slug": "ole-henriksen-plumping-peptide-pair-mini-skincare-duo",
    "name": "Ole Henriksen Plumping Peptide Pair Mini Skincare Duo",
    "brand": "Ole Henriksen",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 1900,
    "retailPricePence": 1900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/ole-henriksen-plumping-peptide-pair-mini-skincare-duo/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "510",
    "slug": "ole-henriksen-pout-preserve-sugar-melt-lip-scrub-8g-strawberry-sorbet",
    "name": "Ole Henriksen Pout Preserve Sugar Melt Lip Scrub 8g – Strawberry Sorbet",
    "brand": "Ole Henriksen",
    "category": "makeup",
    "packSize": "8g",
    "observedAuroraGbpPence": 1700,
    "retailPricePence": 1700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/ole-henriksen-pout-preserve-sugar-melt-lip-scrub-8g-strawberry-sorbet/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "660",
    "slug": "perricone-md-evening-skincare-bundle",
    "name": "Perricone MD Evening Skincare Bundle",
    "brand": "Perricone MD",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 20400,
    "retailPricePence": 20400,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/perricone-md-evening-skincare-bundle/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "564",
    "slug": "pixi-detoxifeye-eye-patches-serum-30-pairs",
    "name": "PIXI DetoxifEYE Eye Patches serum (30 Pairs)",
    "brand": "PIXI",
    "category": "treatments",
    "packSize": null,
    "observedAuroraGbpPence": 2200,
    "retailPricePence": 2200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/pixi-detoxifeye-eye-patches-serum-30-pairs/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "540",
    "slug": "pixi-exclusive-antioxifeye-eye-mask-goggles-3-masks",
    "name": "PIXI Exclusive AntioxifEYE Eye Mask Goggles – 3 Masks",
    "brand": "PIXI",
    "category": "masks",
    "packSize": null,
    "observedAuroraGbpPence": 600,
    "retailPricePence": 600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/pixi-exclusive-antioxifeye-eye-mask-goggles-3-masks/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1199",
    "slug": "purito-wonder-releaf-centella-unscented-serum-60ml",
    "name": "PURITO Wonder Releaf Centella Unscented Serum 60ml",
    "brand": "PURITO",
    "category": "treatments",
    "packSize": "60ml",
    "observedAuroraGbpPence": 2390,
    "retailPricePence": 2390,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/purito-wonder-releaf-centella-unscented-serum-60ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1129",
    "slug": "round-lab-1025-dokdo-toner-200ml",
    "name": "Round Lab 1025 Dokdo Toner 200ml",
    "brand": "Round Lab",
    "category": "treatments",
    "packSize": "200ml",
    "observedAuroraGbpPence": 1700,
    "retailPricePence": 1700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/round-lab-1025-dokdo-toner-200ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1105",
    "slug": "round-lab-birch-juice-cleanser-150ml",
    "name": "Round Lab Birch Juice Cleanser 150ml",
    "brand": "Round Lab",
    "category": "cleansers",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1500,
    "retailPricePence": 1500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/round-lab-birch-juice-cleanser-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1108",
    "slug": "round-lab-birch-juice-moisturising-mask-10-pack",
    "name": "Round Lab Birch Juice Moisturising Mask (10 Pack)",
    "brand": "Round Lab",
    "category": "masks",
    "packSize": null,
    "observedAuroraGbpPence": 3000,
    "retailPricePence": 3000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/round-lab-birch-juice-moisturising-mask-10-pack/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1147",
    "slug": "round-lab-birch-juice-sun-cream-spf50-50ml",
    "name": "Round Lab Birch Juice Sun Cream SPF50 50ml",
    "brand": "Round Lab",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 2100,
    "retailPricePence": 2100,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/round-lab-birch-juice-sun-cream-spf50-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1120",
    "slug": "round-lab-skincare-1025-dokdo-cleansing-oil-200ml",
    "name": "Round Lab Skincare 1025 Dokdo Cleansing Oil 200ml",
    "brand": "Round Lab",
    "category": "cleansers",
    "packSize": "200ml",
    "observedAuroraGbpPence": 2000,
    "retailPricePence": 2000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/round-lab-skincare-1025-dokdo-cleansing-oil-200ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "715",
    "slug": "silkn-facial-led-mask-100-leds",
    "name": "Silk’n Facial LED Mask 100 LEDS",
    "brand": "Silk’n",
    "category": "devices",
    "packSize": null,
    "observedAuroraGbpPence": 16000,
    "retailPricePence": 16000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/silkn-facial-led-mask-100-leds/",
    "likelyBundle": false,
    "needsElectricalReview": true
  },
  {
    "auroraId": "623",
    "slug": "silkn-led-face-ems-mask",
    "name": "Silk’n LED Face EMS Mask",
    "brand": "Silk’n",
    "category": "devices",
    "packSize": null,
    "observedAuroraGbpPence": 29900,
    "retailPricePence": 29900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/silkn-led-face-ems-mask/",
    "likelyBundle": false,
    "needsElectricalReview": true
  },
  {
    "auroraId": "1184",
    "slug": "skin1004-madagascar-centella-hyalu-cica-water-fit-sun-serum-spf50-pa-50ml",
    "name": "SKIN1004 Madagascar Centella Hyalu-Cica Water-Fit Sun Serum SPF50+ PA++++ 50ml",
    "brand": "SKIN1004",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 1800,
    "retailPricePence": 1800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/skin1004-madagascar-centella-hyalu-cica-water-fit-sun-serum-spf50-pa-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1102",
    "slug": "skin1004-madagascar-centella-light-cleansing-oil-200ml",
    "name": "SKIN1004 Madagascar Centella Light Cleansing Oil 200ml",
    "brand": "SKIN1004",
    "category": "cleansers",
    "packSize": "200ml",
    "observedAuroraGbpPence": 2200,
    "retailPricePence": 2200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/skin1004-madagascar-centella-light-cleansing-oil-200ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "991",
    "slug": "sol-de-janeiro-beija-flor-jet-set",
    "name": "Sol de Janeiro Beija Flor Jet Set",
    "brand": "Sol de Janeiro",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 3000,
    "retailPricePence": 3000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/sol-de-janeiro-beija-flor-jet-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1031",
    "slug": "sol-de-janeiro-body-badalada-vitamin-infused-body-lotion-400ml",
    "name": "Sol de Janeiro Body Badalada Vitamin Infused Body Lotion 400ml",
    "brand": "Sol de Janeiro",
    "category": "body-care",
    "packSize": "400ml",
    "observedAuroraGbpPence": 3200,
    "retailPricePence": 3200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/sol-de-janeiro-body-badalada-vitamin-infused-body-lotion-400ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1025",
    "slug": "sol-de-janeiro-bom-dia-jet-set",
    "name": "Sol de Janeiro Bom Dia Jet Set",
    "brand": "Sol de Janeiro",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 3000,
    "retailPricePence": 3000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/sol-de-janeiro-bom-dia-jet-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1010",
    "slug": "sol-de-janeiro-bum-bum-jet-set",
    "name": "Sol de Janeiro Bum Bum Jet Set",
    "brand": "Sol de Janeiro",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 3000,
    "retailPricePence": 3000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/sol-de-janeiro-bum-bum-jet-set/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "890",
    "slug": "stylpro-wavelength-led-face-mask",
    "name": "StylPro Wavelength LED Face Mask",
    "brand": "StylPro",
    "category": "devices",
    "packSize": null,
    "observedAuroraGbpPence": 9995,
    "retailPricePence": 9995,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/stylpro-wavelength-led-face-mask/",
    "likelyBundle": false,
    "needsElectricalReview": true
  },
  {
    "auroraId": "1073",
    "slug": "the-beauty-crop-oui-cherie-mist-100ml",
    "name": "The Beauty Crop Oui Cherie Mist 100ml",
    "brand": "The Beauty Crop",
    "category": "treatments",
    "packSize": "100ml",
    "observedAuroraGbpPence": 1000,
    "retailPricePence": 1000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-beauty-crop-oui-cherie-mist-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "546",
    "slug": "the-glow-edit-emily-english-x-perricone-md",
    "name": "The Glow Edit Emily English x Perricone MD",
    "brand": "The Glow Edit",
    "category": "other",
    "packSize": null,
    "observedAuroraGbpPence": 8900,
    "retailPricePence": 8900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-glow-edit-emily-english-x-perricone-md/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "757",
    "slug": "the-inkey-list-bio-active-ceramide-moisturizer-50ml",
    "name": "The INKEY List Bio-Active Ceramide Moisturizer 50ml",
    "brand": "The INKEY List",
    "category": "moisturisers",
    "packSize": "50ml",
    "observedAuroraGbpPence": 1899,
    "retailPricePence": 1899,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-inkey-list-bio-active-ceramide-moisturizer-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "742",
    "slug": "the-inkey-list-caffeine-eye-cream-15ml",
    "name": "The INKEY List Caffeine Eye Cream 15ml",
    "brand": "The INKEY List",
    "category": "treatments",
    "packSize": "15ml",
    "observedAuroraGbpPence": 1000,
    "retailPricePence": 1000,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-inkey-list-caffeine-eye-cream-15ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1007",
    "slug": "the-inkey-list-glycolic-acid-exfoliating-body-stick-45g",
    "name": "The INKEY List Glycolic Acid Exfoliating Body Stick 45g",
    "brand": "The INKEY List",
    "category": "body-care",
    "packSize": "45g",
    "observedAuroraGbpPence": 1500,
    "retailPricePence": 1500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-inkey-list-glycolic-acid-exfoliating-body-stick-45g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "736",
    "slug": "the-inkey-list-oat-cleansing-balm-150ml",
    "name": "The INKEY List Oat Cleansing Balm 150ml",
    "brand": "The INKEY List",
    "category": "cleansers",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1200,
    "retailPricePence": 1200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-inkey-list-oat-cleansing-balm-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1048",
    "slug": "the-inkey-list-salicylic-acid-cleanser-150m",
    "name": "The INKEY List Salicylic Acid Cleanser 150m",
    "brand": "The INKEY List",
    "category": "cleansers",
    "packSize": null,
    "observedAuroraGbpPence": 1200,
    "retailPricePence": 1200,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-inkey-list-salicylic-acid-cleanser-150m/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "558",
    "slug": "the-inkey-list-starter-retinol-serum-30ml",
    "name": "The INKEY List Starter Retinol Serum 30ml",
    "brand": "The INKEY List",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 1299,
    "retailPricePence": 1299,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-inkey-list-starter-retinol-serum-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "897",
    "slug": "the-ordinary-10-argireline-solution-30ml",
    "name": "The Ordinary 10% Argireline Solution 30ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 920,
    "retailPricePence": 920,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-10-argireline-solution-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "966",
    "slug": "the-ordinary-aha-30-bha-2-peeling-solution-30ml",
    "name": "The Ordinary AHA 30% + BHA 2% Peeling Solution 30ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 890,
    "retailPricePence": 890,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-aha-30-bha-2-peeling-solution-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "718",
    "slug": "the-ordinary-azelaic-acid-suspension-10-30ml",
    "name": "The Ordinary Azelaic Acid Suspension 10% 30ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 1110,
    "retailPricePence": 1110,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-azelaic-acid-suspension-10-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "855",
    "slug": "the-ordinary-glycolic-acid-7-exfoliating-toner-100ml",
    "name": "The Ordinary Glycolic Acid 7% Exfoliating Toner 100ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "100ml",
    "observedAuroraGbpPence": 800,
    "retailPricePence": 800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-glycolic-acid-7-exfoliating-toner-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "690",
    "slug": "the-ordinary-glycolic-acid-7-exfoliating-toner-240ml",
    "name": "The Ordinary Glycolic Acid 7% Exfoliating Toner 240ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "240ml",
    "observedAuroraGbpPence": 1190,
    "retailPricePence": 1190,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-glycolic-acid-7-exfoliating-toner-240ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "709",
    "slug": "the-ordinary-hyaluronic-acid-2-b5-60ml",
    "name": "The Ordinary Hyaluronic Acid 2% + B5 60ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "60ml",
    "observedAuroraGbpPence": 1550,
    "retailPricePence": 1550,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-hyaluronic-acid-2-b5-60ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "766",
    "slug": "the-ordinary-hyaluronic-acid-2-and-b5-30ml",
    "name": "The Ordinary Hyaluronic Acid 2% and B5 30ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 880,
    "retailPricePence": 880,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-hyaluronic-acid-2-and-b5-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "712",
    "slug": "the-ordinary-natural-moisturizing-factors-ha-100ml",
    "name": "The Ordinary Natural Moisturizing Factors + HA 100ml",
    "brand": "The Ordinary",
    "category": "moisturisers",
    "packSize": "100ml",
    "observedAuroraGbpPence": 1140,
    "retailPricePence": 1140,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-natural-moisturizing-factors-ha-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "751",
    "slug": "the-ordinary-niacinamide-10-zinc-1-serum-30ml",
    "name": "The Ordinary Niacinamide 10% + Zinc 1% Serum 30ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 500,
    "retailPricePence": 500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-niacinamide-10-zinc-1-serum-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "697",
    "slug": "the-ordinary-niacinamide-10-zinc-1-supersize-serum-60ml",
    "name": "The Ordinary Niacinamide 10% + Zinc 1% Supersize Serum 60ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "60ml",
    "observedAuroraGbpPence": 900,
    "retailPricePence": 900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-niacinamide-10-zinc-1-supersize-serum-60ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "763",
    "slug": "the-ordinary-retinol-serum-0-2-in-squalane-30ml",
    "name": "The Ordinary Retinol Serum 0.2% in Squalane 30ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 740,
    "retailPricePence": 740,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-retinol-serum-0-2-in-squalane-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "908",
    "slug": "the-ordinary-retinol-serum-1-in-squalane-30ml",
    "name": "The Ordinary Retinol Serum 1% in Squalane 30ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 900,
    "retailPricePence": 900,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-retinol-serum-1-in-squalane-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "502",
    "slug": "the-ordinary-rice-lipids-ectoin-microemulsion-ultra-light-moisturiser-120ml",
    "name": "The Ordinary Rice Lipids + Ectoin Microemulsion Ultra-Light Moisturiser 120ml",
    "brand": "The Ordinary",
    "category": "moisturisers",
    "packSize": "120ml",
    "observedAuroraGbpPence": 2150,
    "retailPricePence": 2150,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-rice-lipids-ectoin-microemulsion-ultra-light-moisturiser-120ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "493",
    "slug": "the-ordinary-rice-lipids-ectoin-microemulsion-ultra-light-moisturiser-60ml",
    "name": "The Ordinary Rice Lipids + Ectoin Microemulsion Ultra-Light Moisturiser 60ml",
    "brand": "The Ordinary",
    "category": "moisturisers",
    "packSize": "60ml",
    "observedAuroraGbpPence": 1240,
    "retailPricePence": 1240,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-rice-lipids-ectoin-microemulsion-ultra-light-moisturiser-60ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1084",
    "slug": "the-ordinary-saccharomyces-ferment-30-milky-toner-100ml",
    "name": "The Ordinary Saccharomyces Ferment 30% Milky Toner 100ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "100ml",
    "observedAuroraGbpPence": 1240,
    "retailPricePence": 1240,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-saccharomyces-ferment-30-milky-toner-100ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "775",
    "slug": "the-ordinary-salicylic-acid-2-solution-30ml",
    "name": "The Ordinary Salicylic Acid 2% Solution 30ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "30ml",
    "observedAuroraGbpPence": 610,
    "retailPricePence": 610,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-salicylic-acid-2-solution-30ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "796",
    "slug": "the-ordinary-squalane-cleanser-150ml",
    "name": "The Ordinary Squalane Cleanser 150ml",
    "brand": "The Ordinary",
    "category": "cleansers",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1490,
    "retailPricePence": 1490,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-squalane-cleanser-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1056",
    "slug": "the-ordinary-the-clear-set-for-blemish-prone-skin-with-salicylic-acid-2",
    "name": "The Ordinary The Clear Set for Blemish-Prone Skin with Salicylic Acid",
    "brand": "The Ordinary",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 1510,
    "retailPricePence": 1510,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-the-clear-set-for-blemish-prone-skin-with-salicylic-acid-2/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "555",
    "slug": "the-ordinary-volufiline-92-pal-isoleucine-1-plumping-serum-15ml",
    "name": "The Ordinary Volufiline 92% + Pal-Isoleucine 1% Plumping Serum 15ml",
    "brand": "The Ordinary",
    "category": "treatments",
    "packSize": "15ml",
    "observedAuroraGbpPence": 1950,
    "retailPricePence": 1950,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/the-ordinary-volufiline-92-pal-isoleucine-1-plumping-serum-15ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1150",
    "slug": "tocobo-aha-bha-lemon-toner-150ml",
    "name": "TOCOBO Aha Bha Lemon Toner 150ml",
    "brand": "TOCOBO",
    "category": "treatments",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1800,
    "retailPricePence": 1800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/tocobo-aha-bha-lemon-toner-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1269",
    "slug": "tocobo-cica-calming-sun-serum-spf50-pa-50ml",
    "name": "TOCOBO Cica Calming Sun Serum SPF50+ Pa++++ 50ml",
    "brand": "TOCOBO",
    "category": "suncare",
    "packSize": "50ml",
    "observedAuroraGbpPence": 1600,
    "retailPricePence": 1600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/tocobo-cica-calming-sun-serum-spf50-pa-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1099",
    "slug": "tocobo-cotton-soft-sun-stick-spf50-pa-19g",
    "name": "TOCOBO Cotton Soft Sun Stick SPF50+ Pa+++ 19g",
    "brand": "TOCOBO",
    "category": "suncare",
    "packSize": "19g",
    "observedAuroraGbpPence": 1700,
    "retailPricePence": 1700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/tocobo-cotton-soft-sun-stick-spf50-pa-19g/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "666",
    "slug": "tocobo-glowing-skin-trio",
    "name": "Tocobo Glowing Skin Trio",
    "brand": "TOCOBO",
    "category": "sets",
    "packSize": null,
    "observedAuroraGbpPence": 6600,
    "retailPricePence": 6600,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/tocobo-glowing-skin-trio/",
    "likelyBundle": true,
    "needsElectricalReview": false
  },
  {
    "auroraId": "930",
    "slug": "uklash-eyelash-serum-3ml-3-month-supply",
    "name": "UKLASH Eyelash Serum 3ml (3 Month Supply)",
    "brand": "UKLASH",
    "category": "treatments",
    "packSize": "3ml",
    "observedAuroraGbpPence": 3800,
    "retailPricePence": 3800,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/uklash-eyelash-serum-3ml-3-month-supply/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1016",
    "slug": "urban-decay-all-nighter-setting-spray-118ml",
    "name": "Urban Decay All Nighter Setting Spray 118ml",
    "brand": "Urban Decay",
    "category": "makeup",
    "packSize": "118ml",
    "observedAuroraGbpPence": 2950,
    "retailPricePence": 2950,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/urban-decay-all-nighter-setting-spray-118ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "642",
    "slug": "vichy-mineral-89-hyaluronic-acid-booster-serum-75ml",
    "name": "Vichy Mineral 89 Hyaluronic Acid Booster Serum 75ml",
    "brand": "Vichy",
    "category": "treatments",
    "packSize": "75ml",
    "observedAuroraGbpPence": 3500,
    "retailPricePence": 3500,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/vichy-mineral-89-hyaluronic-acid-booster-serum-75ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "1260",
    "slug": "wella-professionals-care-color-fresh-semi-permanent-colour-mask-pearl-blonde-150ml",
    "name": "Wella Professionals Care Color Fresh Semi-Permanent Colour Mask – Pearl Blonde 150ml",
    "brand": "Wella Professionals",
    "category": "hair",
    "packSize": "150ml",
    "observedAuroraGbpPence": 1670,
    "retailPricePence": 1670,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/wella-professionals-care-color-fresh-semi-permanent-colour-mask-pearl-blonde-150ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  },
  {
    "auroraId": "935",
    "slug": "yves-saint-laurent-libre-eau-de-parfum-50ml",
    "name": "Yves Saint Laurent Libre Eau de Parfum 50ml",
    "brand": "Yves Saint Laurent",
    "category": "fragrance",
    "packSize": "50ml",
    "observedAuroraGbpPence": 10700,
    "retailPricePence": 10700,
    "dateChecked": "2026-09-23",
    "sourceUrl": "https://www.aurorabeautiful.com/product/yves-saint-laurent-libre-eau-de-parfum-50ml/",
    "likelyBundle": false,
    "needsElectricalReview": false
  }
];
